type Param = {
  day: 'numeric' | '2-digit';
  month: 'numeric' | '2-digit' | 'long' | 'short' | 'narrow';
  year: 'numeric' | '2-digit';
};

export function parseDate(date: Date, parseParam: Param, locale?: string) {
  let year = date.toLocaleDateString(locale || undefined, {
    year: parseParam.year,
  });
  let month = date.toLocaleDateString(locale || undefined, {
    month: parseParam.month,
  });
  let day = date.toLocaleDateString(locale || undefined, {
    day: parseParam.day,
  });
  return { day, month, year };
}
